'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useRouter } from 'next/navigation';
import { useOverlay } from '@/app/components/overlays/hooks/useOverlay';
import { Modal } from '@/app/components/overlays/modal';
import type { ModalStatusResultProps } from '@/app/components/sections/register/modals/types';
import { MODAL_KEYS } from '@/app/constants/overlayKeys';
import { cn } from '@/app/utils/cn';
import { safeCall } from '@/app/utils/safeCall';
const ErrorModalContent = dynamic(() => import('@/app/components/sections/register/modals/modal-status-result/error').then(mod => mod.ErrorModalContent), {
  ssr: false
});
const SuccessModalContent = dynamic(() => import('@/app/components/sections/register/modals/modal-status-result/success').then(mod => mod.SuccessModalContent), {
  ssr: false
});
export const ModalStatusResult = t0 => {
  const $ = _c(24);
  const {
    modalState,
    theme: t1,
    successMsg,
    buttons: t2,
    okButtonLabel: t3,
    cancelButtonLabel: t4,
    redirectToHome: t5,
    onClose
  } = t0;
  const theme = t1 === undefined ? "light" : t1;
  let t6;
  if ($[0] !== t2) {
    t6 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const buttons = t6;
  const okButtonLabel = t3 === undefined ? "\u0E01\u0E25\u0E31\u0E1A\u0E2A\u0E39\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01" : t3;
  const cancelButtonLabel = t4 === undefined ? "\u0E15\u0E01\u0E25\u0E07" : t4;
  const redirectToHome = t5 === undefined ? true : t5;
  const router = useRouter();
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      overlayKey: MODAL_KEYS.MODAL_FORM,
      instanceId: "cv-register-form"
    };
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const modal = useOverlay(t7);
  let t8;
  if ($[3] !== onClose || $[4] !== router) {
    t8 = t9 => {
      const isRedirect = t9 === undefined ? false : t9;
      safeCall(onClose, isRedirect);
      if (isRedirect) {
        router.push("/");
      }
    };
    $[3] = onClose;
    $[4] = router;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const handleClose = t8;
  if (!modalState.isError && !modalState.isSuccess) {
    return null;
  }
  const t9 = modal.overlayProps;
  const t10 = theme === "light";
  const t11 = theme === "dark";
  let t12;
  if ($[6] !== t10 || $[7] !== t11) {
    t12 = cn("text-center md:h-fit md:max-w-164 md:rounded-sm", {
      "text-gray-900": t10,
      "text-white": t11
    });
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  let t13;
  if ($[9] !== buttons || $[10] !== cancelButtonLabel || $[11] !== handleClose || $[12] !== modalState.isError || $[13] !== okButtonLabel || $[14] !== redirectToHome || $[15] !== successMsg || $[16] !== theme) {
    t13 = modalState.isError ? <ErrorModalContent theme={theme} onClick={handleClose} buttonLabel={cancelButtonLabel} /> : <SuccessModalContent theme={theme} buttonLabel={okButtonLabel} onClick={() => handleClose(redirectToHome)} description={successMsg} additionalButtons={buttons} />;
    $[9] = buttons;
    $[10] = cancelButtonLabel;
    $[11] = handleClose;
    $[12] = modalState.isError;
    $[13] = okButtonLabel;
    $[14] = redirectToHome;
    $[15] = successMsg;
    $[16] = theme;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== handleClose || $[19] !== modal.overlayProps || $[20] !== t12 || $[21] !== t13 || $[22] !== theme) {
    t14 = <Modal {...t9} isOpen={true} theme={theme} sizes="sm" className={t12} onClose={handleClose}>{t13}</Modal>;
    $[18] = handleClose;
    $[19] = modal.overlayProps;
    $[20] = t12;
    $[21] = t13;
    $[22] = theme;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
};